import React from "react"
import { FormattedMessage } from "react-intl"

export default function SetHeightLoaderFrame({ height = "500" }) {
  return (
    <div className={"dashed-black-border"} style={{ height: `${height}px`, position: "relative" }}>
      <div className="visibleLoaderGif">
        <div className="spinner-border text-primary text-center" role="status" />
        &nbsp;&nbsp;
        <h5>
          <FormattedMessage id={"general.loading"} description={`Loading...`} />
          ...
        </h5>
      </div>
    </div>
  )
}
